'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Online Signature App SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Using Online Signature Apps',
            subtitle: 'HelloSign is a free eSignature app providing a fast, simple, and secure way to sign online',
            buttonText: 'CREATE A FREE ACCOUNT'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is HelloSign an Online Signature App?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'We sure are! HelloSign was founded in 2013 and has since helped hundreds of thousands of people safely and securely sign their documents online. You can learn a little more about what we do by visiting our ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'https://www.hellosign.com/info/tour', target: '_blank', rel: 'noopener noreferrer' },
                    'Tour Page.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Can I use the HelloSign signature app to sign on my mobile phone?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes! Our online signature app is optimized for all your devices, including mobile phones. You can also use HelloSign to sign from your desktop or your tablet. Each device will give you an optimized signer experience that helps you efficiently navigate through any document you need to prepare or sign.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What sets HelloSign apart as an online signature app?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'One of the biggest differentiators at HelloSign is our user-friendly interface. We know admin applications can get hairy and complicated pretty quickly. So our goal has always been to provide a tool that\u2019s both functional and easy to use! This continues to be top priority as as we add new features and integrating with new companies.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What are some of your most valuable features?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Hard pressed, we\u2019d have to say some of our most valuable features include:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Data Validation'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Automation features like \u201CInsert Signature Everywhere\u201D'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'User permissions'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'In-person signing'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'But we have a whole squad of features that help users create their very best signing experience. You can learn about all our ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'https://www.hellosign.com/info/tour', target: '_blank', rel: 'noopener noreferrer' },
                    'features here'
                ),
                '!'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Does your signature app integrate with any other companies?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'We do! We\u2019ve integrated with quite a few companies over the years to bring online signing directly to the applications you use most. Since our first integration with Google, we\u2019ve integrated with companies like ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/dropbox/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Dropbox'
                ),
                ', ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Evernote'
                ),
                ', Box, ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Slack'
                ),
                ', and the ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'HubSpot CRM'
                ),
                '.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Try The HelloSign App',
            subtitle: 'We’d love to have you take a look! You can create a free account and start signing in under 5 minutes. If you want to take a look at some of the features included in our Pro plans, visit our plan page.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/online-signature-app.jsx
 ** module id = 1224
 ** module chunks = 0
 **/